import React from 'react'
import OrangeVipStandardZero from '../components/dashboard/OrangeVipStandardZero'

const OrangeVipStandardZeroPage = () => <OrangeVipStandardZero showPolkoweFilter />

export default OrangeVipStandardZeroPage
